import { HYPERSWITCH_ELEMENT_OPTIONS } from '../common/constants/hyperswitchAppearance';

export function isApplePayDevice(scope: any = globalThis): boolean {
  return Boolean(scope?.ApplePaySession?.canMakePayments?.());
}

export function buildHyperswitchWallets(
  returnUrl: string,
  applePayDevice: boolean,
): Record<string, unknown> {
  const wallets: Record<string, unknown> = {
    ...HYPERSWITCH_ELEMENT_OPTIONS.wallets,
    walletReturnUrl: returnUrl,
  };

  if (applePayDevice) {
    wallets.googlePay = { ...HYPERSWITCH_ELEMENT_OPTIONS.wallets.googlePay, display: 'never' };
  }

  return wallets;
}

export function buildCardOnlyWallets(returnUrl: string): Record<string, unknown> {
  const { applePay, googlePay } = HYPERSWITCH_ELEMENT_OPTIONS.wallets;

  return {
    ...HYPERSWITCH_ELEMENT_OPTIONS.wallets,
    applePay: { ...applePay, display: 'never' },
    googlePay: { ...googlePay, display: 'never' },
    walletReturnUrl: returnUrl,
  };
}
